<!-- <section *ngIf="(update || updateUI) && (this.loginUser?.full_name == 'Administrator')" class="updateBlink">

    <div class=" py-2">
        <div class="row m-0 p-0">
            <div class="col-md-11">
                <p class="p-0 m-0 text-center text-white">New Update is available. <a class="blink_me ml-5" (click)="updateNow()">Update Now</a></p>
            </div>

            <div class="col-md-1">
                <button type="button" class="close pr-3" aria-label="Close" (click)="closeUpdate()">
                    <span aria-hidden="true" class="text-white"><i class="ri-close-fill"></i></span>
                </button>
            </div>
        </div>
    </div>
</section> -->
<section class="c-header" [ngClass]="{ 'c-h-header': screenAdjust }">
  <div class="container-fluid p-3 px-md-5">
    <div class="row no-gutters">
      <div class="col-md-2 my-auto">
        <span class="logo"><img class="img-fluid" (click)="navigateDashboard()"
            on-click="selectedValue.value = 'Dashboard'" src="assets/images/EzyInvoicelogo.svg" alt="logo" /></span>
      </div>
      <div class="col-lg-2 col-md-2">
        <div class="d-flex flex-row">
          <span class="ml-4 align-self-center">
            <div ngbDropdown class="d-inline-block" id="menu-dropdown">
              <button class="btn btn-default" id="dropdownBasic1" ngbDropdownToggle>
                <span class="mr-4 text-truncate-c">{{ activeLinkName }}</span>
              </button>
              <ng-container>
                <div class="border-0 shadow p-3" ngbDropdownMenu aria-labelledby="dropdownBasic1" #selectedValue>
                  <div class="row">
                    <div class="col">
                      <h4 class="py-2">Activity</h4>
                      <div class="">
                        <button [ngClass]="{
                            'link-active': activeLinkName == 'Dashboard'
                          }" (click)="selectedMenu('Dashboard')" [routerLink]="['/home/dashboard']"
                          routerLinkActive="router-link-active" ngbDropdownItem
                          on-click="selectedValue.value = 'Dashboard'">
                          Dashboard
                        </button>
                        <!-- <button
                          [ngClass]="{
                            'link-active': activeLinkName == 'Health Dashboard'
                          }"
                          (click)="selectedMenu('Health Dashboard')"
                          [routerLink]="['/home/health-dashboard']"
                          routerLinkActive="router-link-active"
                          ngbDropdownItem
                          on-click="selectedValue.value = 'Health Dashboard'"
                        >
                          Health Dashboard
                        </button> -->
                        <!-- <button [routerLink]="['/home/company']" routerLinkActive="router-link-active"
                                            ngbDropdownItem on-click="selectedValue.value='Company'">Company</button> -->
                        <button (click)="selectedMenu('Sales Invoices')" [ngClass]="{
                            'link-active': activeLinkName == 'Sales Invoices'
                          }" ngbDropdownItem on-click="selectedValue.value = 'Invoices'">
                          Sales Invoices
                        </button>

                        <button (click)="selectedMenu('> 10000 RM')" [ngClass]="{
                            'link-active': activeLinkName == '> 10000 RM'
                          }" ngbDropdownItem [routerLink]="['/home/rm-tenthousand']"
                          routerLinkActive="router-link-active">
                          High Value Invoices & Checks
                        </button>

                        <button (click)="selectedMenu('Country Mismatch (TTX)')" [ngClass]="{
                            'link-active': activeLinkName == 'Country Mismatch (TTX)'
                          }" ngbDropdownItem [routerLink]="['/home/country-mismatch']"
                          routerLinkActive="router-link-active">
                          Country Mismatch (TTX)
                        </button>

                        <!-- <button
                          [ngClass]="{
                            'link-active': activeLinkName == 'SYS. Credit Notes'
                          }"
                          (click)="selectedMenu('Credit Notes')"
                          [routerLink]="['/home/credit-invoices']"
                          routerLinkActive="router-link-active"
                          ngbDropdownItem
                          on-click="selectedValue.value = 'Credit Notes'"
                        >
                          SYS. Credit Notes
                        </button> -->

                        <button *ngIf="companyDetails?.manual_credit_invoice == '1'" [ngClass]="{
                            'link-active': activeLinkName == 'Manual Sales Invoices'
                          }" (click)="selectedMenu('Manual Sales Invoices')" [routerLink]="['/home/manual-credit-notes']"
                          routerLinkActive="router-link-active" ngbDropdownItem
                          on-click="selectedValue.value = 'Manual Sales Invoices'">
                          Manual Sales Invoices
                        </button>

                        <button [ngClass]="{
                            'link-active':
                              activeLinkName == 'Self Billed Invoices'
                          }" (click)="selectedMenu('Self Billed Invoices')"
                          [routerLink]="['/home/self-billed-invoices']" routerLinkActive="router-link-active"
                          ngbDropdownItem on-click="
                            selectedValue.value = 'Self Billed Invoices'
                          ">
                          Self Billed Invoices
                        </button>

                        <button [ngClass]="{
                            'link-active':
                              activeLinkName == 'Pos Checks'
                          }" (click)="selectedMenu('Pos Checks')" [routerLink]="['/home/pos-checks']"
                          routerLinkActive="router-link-active" ngbDropdownItem on-click="
                            selectedValue.value = 'Pos Checks'
                          ">
                          Pos Checks
                        </button>


                        <button [ngClass]="{
                          'link-active': activeLinkName == 'Purchase Invoices'
                        }" [routerLink]="['/home/purchase-invoices']" (click)="selectedMenu('Purchase Invoices')"
                          routerLinkActive="router-link-active" ngbDropdownItem
                          on-click="selectedValue.value = 'Purchase Invoices'">
                          Purchase Invoices
                        </button>
                        <button *ngIf="
                            companyDetails?.bulk_upload_d110_xml_file ==
                            'Light Speed PMS'
                          " [ngClass]="{
                            'link-active': activeLinkName == 'Grouped Invoices'
                          }" (click)="selectedMenu('Grouped Invoices')" [routerLink]="['/home/grouped-invoices']"
                          routerLinkActive="router-link-active" ngbDropdownItem
                          on-click="selectedValue.value = 'Grouped Invoices'">
                          Grouped Invoices
                        </button>
                        <button (click)="selectedMenu('Information_invoice')" *ngIf="
                            this.companyDetails
                              ?.pms_information_invoice_for_payment_qr == 'Yes'
                          " [routerLink]="['/home/Information_invoice']" routerLinkActive="router-link-active"
                          [ngClass]="{
                            'link-active':
                              activeLinkName == 'Information Invoice'
                          }" ngbDropdownItem on-click="selectedValue.value = 'Information_invoice'">
                          Information Invoice
                        </button>
                        <button (click)="selectedMenu('B2C invoices')" [ngClass]="{
                            'link-active': activeLinkName == 'B2C Consolidation'
                          }" [routerLink]="['/b2c/all-invoices']" on-click="selectedValue.value = 'B2C invoices'"
                          routerLinkActive="router-link-active" ngbDropdownItem>
                          B2C Consolidation
                        </button>
                        <button (click)="selectedMenu('AR accounts')" [ngClass]="{
                            'link-active': activeLinkName == 'AR Accounts'
                          }" [routerLink]="['/home/ar-invoices']" on-click="selectedValue.value = 'AR accounts'"
                          routerLinkActive="router-link-active" ngbDropdownItem>
                          AR Accounts
                        </button>

                        <!-- <button
                          [ngClass]="{
                            'link-active': activeLinkName == 'SYS. Credit Notes'
                          }"
                          (click)="selectedMenu('Credit Notes')"
                          [routerLink]="['/home/credit-invoices']"
                          routerLinkActive="router-link-active"
                          ngbDropdownItem
                          on-click="selectedValue.value = 'Credit Notes'"
                        >
                          SYS. Credit Notes
                        </button> -->

                        <!--                         
                        <button
                          *ngIf="companyDetails?.manual_credit_invoice == '1'"
                          [ngClass]="{
                            'link-active': activeLinkName == 'Credit Notes'
                          }"
                          (click)="selectedMenu('Manual Credit Notes')"
                          [routerLink]="['/home/manual-credit-notes']"
                          [queryParams]="{ type: 'Credit' }"
                          routerLinkActive="router-link-active"
                          ngbDropdownItem
                          on-click="selectedValue.value = 'Manual Credit Notes'"
                        >
                          Credit Notes
                        </button>


                        <button
                          *ngIf="companyDetails?.manual_debit_invoice == '1'"
                          [ngClass]="{
                            'link-active': activeLinkName == 'Debit Notes'
                          }"
                          (click)="selectedMenu('Manual Debit Notes')"
                          [routerLink]="['/home/manual-credit-notes']"
                          [queryParams]="{ type: 'Debit' }"
                          routerLinkActive="router-link-active"
                          ngbDropdownItem
                          on-click="selectedValue.value = 'Manual Debit Notes'"
                        >
                          Debit Notes
                        </button>

                        <button
                          *ngIf="companyDetails?.manual_tax_invoice == '1'"
                          [ngClass]="{
                            'link-active':
                              activeLinkName == 'Manual Tax Invoices'
                          }"
                          (click)="selectedMenu('Manual Tax Invoices')"
                          [routerLink]="['/home/manual-credit-notes']"
                          [queryParams]="{ type: 'Tax' }"
                          routerLinkActive="router-link-active"
                          ngbDropdownItem
                          on-click="selectedValue.value = 'Manual Tax Invoices'"
                        >
                          Manual Tax Invoices
                        </button> -->

                        <button *ngIf="companyDetails?.bulk_excel_upload_type" [ngClass]="{
                            'link-active': activeLinkName == 'Upload Invoices'
                          }" (click)="selectedMenu('Upload Invoices')" [routerLink]="['/home/upload-invoice']"
                          routerLinkActive="router-link-active" ngbDropdownItem
                          on-click="selectedValue.value = 'Upload Invoices'">
                          Upload Invoices
                        </button>
                        <button [ngClass]="{
                            'link-active':
                              activeLinkName == 'Simple Reconciliation'
                          }" [routerLink]="['/home/invoice-reconciliation']"
                          (click)="selectedMenu('Simple Reconciliation')" routerLinkActive="router-link-active"
                          ngbDropdownItem on-click="
                            selectedValue.value = 'Simple Reconciliation'
                          ">
                          Simple Reconciliation
                        </button>

                        <button *ngIf="companyDetails?.ezy_gst_module == 1" [ngClass]="{
                            'link-active': activeLinkName == 'Amended Invoices'
                          }" [routerLink]="['/home/amend-invoices']" (click)="selectedMenu('Amended Invoices')"
                          routerLinkActive="router-link-active" ngbDropdownItem
                          on-click="selectedValue.value = 'Amended Invoices'">
                          Amended Invoices
                        </button>
                      </div>
                    </div>

                    <div class="col">
                      <h4 class="py-2">Master Data</h4>
                      <div class="">
                        <!-- <button [ngClass]="{'link-active': activeLinkName == 'Payment Types'}" #link [routerLink]="['/home/payment-type']" (click)="selectedMenu('Payment Types')" routerLinkActive="router-link-active" ngbDropdownItem on-click="selectedValue.value='Payment Types'">Payment
                                            Types</button> -->
                        <button [ngClass]="{
                            'link-active':
                              activeLinkName == 'Transaction Code Details '
                          }" [routerLink]="['/home/sac-hsn-codes']" (click)="selectedMenu('Transaction Code Details ')"
                          routerLinkActive="router-link-active" ngbDropdownItem on-click="
                            selectedValue.value = 'Transaction Code Details '
                          ">
                          Transaction Code Details
                        </button>
                        <button [ngClass]="{
                            'link-active':
                              activeLinkName == 'Tax Payers Details'
                          }" [routerLink]="['/home/tax-payers']" (click)="selectedMenu('Tax Payers Details')"
                          routerLinkActive="router-link-active" [queryParams]="{ tab_name: 'regular_tins' }"
                          ngbDropdownItem on-click="selectedValue.value = 'Tax Payers Details'">
                          Tax payer details
                        </button>
                        <button [ngClass]="{
                            'link-active': activeLinkName == 'User Management'
                          }" [routerLink]="['/home/users']" (click)="selectedMenu('User Management')"
                          routerLinkActive="router-link-active" ngbDropdownItem
                          on-click="selectedValue.value = 'User Management'">
                          User Management
                        </button>
                        <button [ngClass]="{
                            'link-active': activeLinkName == 'Role Management'
                          }" [routerLink]="['/home/roles']" (click)="selectedMenu('Role Management')"
                          routerLinkActive="router-link-active" ngbDropdownItem
                          on-click="selectedValue.value = 'Role Management'">
                          Role Management
                        </button>
                        <button [ngClass]="{
                            'link-active': activeLinkName == 'Permissions'
                          }" [routerLink]="['/home/permissions']" (click)="selectedMenu('Permissions')"
                          routerLinkActive="router-link-active" ngbDropdownItem
                          on-click="selectedValue.value = 'Permissions'">
                          Permissions
                        </button>
                        <button [ngClass]="{
                            'link-active':
                              activeLinkName == 'E-invoice Requests'
                          }" [routerLink]="['/home/e-invoice-requests']" (click)="selectedMenu('E-invoice Requests')"
                          routerLinkActive="router-link-active" ngbDropdownItem
                          on-click="selectedValue.value = 'E-invoice Requests'">
                          E-Invoice Requests
                        </button>
                        <button [ngClass]="{
                            'link-active':
                              activeLinkName == 'Foreign Exchange rates'
                          }" [routerLink]="['/home/foreign-exchange-rates']"
                          (click)="selectedMenu('Foreign Exchange rates')" routerLinkActive="router-link-active"
                          ngbDropdownItem on-click="selectedValue.value = 'E-invoice Requests'">
                          Foreign Exchange rates
                        </button>

                        <button *ngIf="companyDetails?.ezy_gst_module == 1" [ngClass]="{
                            'link-active': activeLinkName == 'sync-history'
                          }" [routerLink]="['/home/sync-history']" (click)="selectedMenu('sync-history')"
                          routerLinkActive="router-link-active" ngbDropdownItem
                          on-click="selectedValue.value = 'sync-history'">
                          Sync History
                        </button>
                        <!-- <button *ngIf="companyDetails?.ezy_gst_module == 1 " (click)="selectedMenu('SYNC')" ngbDropdownItem>
                                        Sync History
                                    </button> -->
                      </div>
                    </div>

                    <div class="col">
                      <h4 class="py-2">Reports</h4>
                      <div class="">
                        <button [ngClass]="{
                            'link-active': activeLinkName == 'Reports'
                          }" [routerLink]="['/home/reports']" (click)="selectedMenu('Reports')"
                          routerLinkActive="router-link-active" on-click="selectedValue.value = 'Reports'"
                          ngbDropdownItem>
                          Reports
                        </button>
                        <button [ngClass]="{
                            'link-active': activeLinkName == 'Deleted Documents'
                          }" [routerLink]="['/home/deleted-documents']" (click)="selectedMenu('Deleted Documents')"
                          routerLinkActive="router-link-active" ngbDropdownItem
                          on-click="selectedValue.value = 'Deleted Documents'">
                          Deleted Documents
                        </button>
                        <button [ngClass]="{
                            'link-active': activeLinkName == 'Email Logs'
                          }" [routerLink]="['/home/email-logs']" (click)="selectedMenu('Email Logs')"
                          routerLinkActive="router-link-active" ngbDropdownItem
                          on-click="selectedValue.value = 'Email Logs'">
                          Email Logs
                        </button>
                        <!-- <button
                          [ngClass]="{
                            'link-active': activeLinkName == 'Update Logs'
                          }"
                          [routerLink]="['./bench-logs']"
                          routerLinkActive="router-link-active"
                          ngbDropdownItem
                        >
                          Update Logs
                        </button> -->
                        <button [ngClass]="{
                            'link-active': activeLinkName == 'Document Bin'
                          }" [routerLink]="['./document-bin']" routerLinkActive="router-link-active" ngbDropdownItem
                          *ngIf="companyDetails.enable_pdf_upload">
                          Document Bin
                        </button>
                        <button *ngIf="this.companyDetails?.bulk_irn_background_jobs" [ngClass]="{
                            'link-active': activeLinkName == 'Bulk UUID'
                          }" [routerLink]="['./bulk-irn']" routerLinkActive="router-link-active" ngbDropdownItem>
                          Bulk UUID
                        </button>
                      </div>
                    </div>

                    <ng-container *ngIf="
                        userData?.full_name === 'Administrator' ||
                        !loginFrontOfcUser ||
                        checkPOSvthFrontOfc ||
                        loginUSerRole
                      ">
                      <div class="col" *ngIf="
                          companyDetails?.sign_ezy_module == '1' ||
                          (companyDetails?.pos_bills_module == 'Enable' &&
                            companyDetails?.clbs == 0)
                        ">
                        <h4 class="py-2">Ezy Sign</h4>

                        <ng-container *ngIf="
                            userData?.full_name === 'Administrator' ||
                            loginUSerRole ||
                            (!loginFrontOfcUser && !checkPOSvthFrontOfc)
                          ">
                          <div class="" *ngIf="
                              companyDetails?.sign_ezy_module == '1' ||
                              companyDetails?.pos_bills_module == 'Enable'
                            ">
                            <div *ngIf="
                                companyDetails?.pos_bills_module == 'Enable'
                              " class="pt-1">
                              <button (click)="toggle('first')" class="btn btn-default p-0 c-men">
                                <span>POS Bills
                                  <i class="float-right" [ngClass]="{
                                      'ri-arrow-down-s-line': isCollapsed,
                                      'ri-arrow-right-s-line': !isCollapsed
                                    }"></i></span>
                              </button>
                              <div class="ml-1" *ngIf="isCollapsed">
                                <!-- <button [ngClass]="{'link-active': activeLinkName == 'POS Uploads'}" routerLinkActive="router-link-active" [routerLink]="['./pos-uploads']" class="dropdown-item">POS Uploads</button> -->
                                <button [ngClass]="{
                                    'link-active': activeLinkName == 'POS Bills'
                                  }" routerLinkActive="router-link-active" [routerLink]="['./pos-bills']"
                                  class="dropdown-item">
                                  POS Checks
                                </button>
                                <button *ngIf="
                                    companyDetails?.company_code != 'ZBPK-01'
                                  " [ngClass]="{
                                    'link-active':
                                      activeLinkName == 'Print Settings'
                                  }" routerLinkActive="router-link-active" [routerLink]="['./pos-bills-settings']"
                                  class="dropdown-item">
                                  Print Settings
                                </button>
                                <button [ngClass]="{
                                    'link-active': activeLinkName == 'Outlets'
                                  }" routerLinkActive="router-link-active" [routerLink]="['./outlets']"
                                  class="dropdown-item">
                                  Outlets
                                </button>
                                <button *ngIf="
                                    companyDetails?.company_code != 'ZBPK-01'
                                  " [ngClass]="{
                                    'link-active':
                                      activeLinkName == 'POS Printers'
                                  }" routerLinkActive="router-link-active" [routerLink]="['./ip-printer']"
                                  class="dropdown-item">
                                  POS Printers
                                </button>
                                <!-- <button *ngIf="companyDetails?.company_code != 'ZBPK-01'" [ngClass]="{'link-active': activeLinkName == 'POS Reports'}" routerLinkActive="router-link-active" [routerLink]="['./pos-reports']" class="dropdown-item">POS Reports</button> -->
                              </div>
                            </div>

                            <div *ngIf="companyDetails?.sign_ezy_module == '1'" class="pt-1">
                              <button (click)="toggle('second')" class="btn btn-default p-0 c-men">
                                <span>Tab
                                  <i class="float-right" [ngClass]="{
                                      'ri-arrow-down-s-line': isCollapsedOne,
                                      'ri-arrow-right-s-line': !isCollapsedOne
                                    }"></i></span>
                              </button>
                              <div class="ml-1" *ngIf="isCollapsedOne">
                                <button [ngClass]="{
                                    'link-active': activeLinkName == 'Tablets'
                                  }" routerLinkActive="router-link-active" [routerLink]="['./tablet']"
                                  class="dropdown-item" ngbDropdownItem>
                                  Tablet
                                </button>
                                <button [ngClass]="{
                                    'link-active':
                                      activeLinkName == 'Work Stations'
                                  }" routerLinkActive="router-link-active" [routerLink]="['./work-stations']"
                                  class="dropdown-item" ngbDropdownItem>
                                  WorkStations
                                </button>
                                <button [ngClass]="{
                                    'link-active':
                                      activeLinkName == 'Tablet Configurations'
                                  }" routerLinkActive="router-link-active" [routerLink]="['./tablet-conf']"
                                  class="dropdown-item" ngbDropdownItem>
                                  Tablet Configuration
                                </button>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>

                    <div class="col" *ngIf="companyDetails?.payment_reconciliation == 1">
                      <h4 class="py-2">Credit Card Recon</h4>
                      <div>
                        <button [ngClass]="{
                            'link-active':
                              activeLinkName == 'Payment Reconciliation'
                          }" [routerLink]="'./payment-reconciliation'" routerLinkActive="router-link-active"
                          ngbDropdownItem>
                          Payment Reconciliation
                        </button>
                      </div>
                    </div>
                    <div class="col">
                      <h4 class="py-2">Settings</h4>
                      <div>
                        <button [ngClass]="{
                            'link-active': activeLinkName == 'Company'
                          }" [routerLink]="
                            './company-details/' + companyDetails?.name
                          " routerLinkActive="router-link-active" [queryParams]="{ view: true }" ngbDropdownItem>
                          Company
                        </button>

                        <!-- <button
                          [ngClass]="{
                            'link-active': activeLinkName == 'GSP API'
                          }"
                          routerLinkActive="router-link-active"
                          [routerLink]="['./gsp-apis']"
                          ngbDropdownItem
                        >
                          GSP API
                        </button> -->

                        <button [ngClass]="{
                            'link-active': activeLinkName == 'LHDN Details'
                          }" routerLinkActive="router-link-active" [routerLink]="['./lhnd-settings']" ngbDropdownItem>
                          LHDN Settings
                        </button>

                        <!-- <button
                          [ngClass]="{
                            'link-active': activeLinkName == 'Email Settings'
                          }"
                          routerLinkActive="router-link-active"
                          [routerLink]="['./email-smtp']"
                          ngbDropdownItem
                        >
                          Email Settings
                        </button> -->

                        <!-- <button
                          [ngClass]="{
                            'link-active': activeLinkName == 'Faqs'
                          }" routerLinkActive="router-link-active" [routerLink]="['/faqs']" ngbDropdownItem>
                          Faqs
                        </button> -->
                        <button [ngClass]="{
                            'link-active': activeLinkName == 'Error Logs'
                          }" routerLinkActive="router-link-active" [routerLink]="['./error-logs']" ngbDropdownItem>
                          Error Logs
                        </button>
                      </div>
                    </div>

                    <div class="col">
                      <h4 class="py-2">Modules</h4>
                      <div>
                        <!-- <button  *ngIf="companyDetails?.ezy_gst_module == 1" [ngClass]="{'link-active': activeLinkName == 'Advanced Reconcilation'}" [routerLink]="['/home/invoice-recon']" routerLinkActive="router-link-active" ngbDropdownItem on-click="selectedValue.value='Advanced Reconcilation'">Advanced
                                    Reconciliation</button> -->

                        <button *ngIf="companyDetails?.clbs == 1" (click)="selectedMenu('CLBS')" ngbDropdownItem>
                          CLBS
                        </button>
                        <!-- <button *ngIf="companyDetails?.ezy_gst_module == 1" (click)="selectedMenu('GST')" ngbDropdownItem>
                                                Ezy GST
                                                </button> -->

                        <button *ngIf="
                            companyDetails?.pos_bills_module == 'Enable' &&
                            companyDetails?.clbs == 1
                          " (click)="selectedMenu('POS')" ngbDropdownItem>
                          POS Bills
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="posUser">
                <div class="border-0 w-30 shadow p-3" ngbDropdownMenu aria-labelledby="dropdownBasic1" #selectedValue>
                  <div class="row border-bottom">
                    <div class="col">
                      <h4>Ezy Sign</h4>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col" *ngIf="
                        companyDetails?.sign_ezy_module == '1' ||
                        companyDetails?.pos_bills_module == 'Enable'
                      ">
                      <div *ngIf="companyDetails?.pos_bills_module == 'Enable'" class="pt-1">
                        <button (click)="toggle('first')" class="btn btn-default p-0 c-men">
                          <span>POS Bills
                            <i class="float-right" [ngClass]="{
                                'ri-arrow-down-s-line': isCollapsed,
                                'ri-arrow-right-s-line': !isCollapsed
                              }"></i></span>
                        </button>
                        <div class="ml-1" *ngIf="isCollapsed">
                          <button [ngClass]="{
                              'link-active': activeLinkName == 'POS Bills'
                            }" routerLinkActive="router-link-active" [routerLink]="['./pos-bills']"
                            class="dropdown-item">
                            POS Checks
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </span>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 my-auto">
        <div class="status-icons text-center">
          <!-- <span class="text-white"> <i
                            [ngClass]="{'ri-global-line spin bg-success': networkStatus, 'ri-error-warning-line': !networkStatus}"
                            ngbTooltip="Network Status"></i>
                        : {{networkStatus? 'Online' : 'Offline'}}</span>
                <span class="px-2 text-white">|</span> -->
          <span class="text-white">
            <i class="ri-computer-line spin" ngbTooltip="System Status"></i>
            {{ companyDetails?.mode }}</span>
          <span class="px-2 text-white"></span>
          <span class="text-white">
            <i class="ri-building-line spin mr-1" ngbTooltip="Name"></i>
            <span class="text-truncate-company" [ngbTooltip]="companyDetails?.company_name">{{
              companyDetails?.company_name }}</span></span>
          <span class="px-2 text-white"></span>
          <span class="text-white">
            <i class="ri-map-pin-line spin mr-1" ngbTooltip="Branch"></i>
            <span class="" [ngbTooltip]="companyDetails?.location">{{
              companyDetails?.location
              }}</span></span>
          <!-- <ng-container *ngIf="companyDetails?.mode == 'Production'">
            <span class="px-2 text-white"></span>
            <span class="text-white">
              <i class="spin mr-1" style="font-size: 11px; padding: 5px 8px"
                >#</i
              >

              <span class="" [ngbTooltip]="companyDetails?.gst_number">{{
                companyDetails?.gst_number
              }}</span></span
            >
          </ng-container> -->
        </div>
      </div>
      <div class="col-lg-2 col-md-2 text-right">
        <!-- <div class="border border-0 p-2 text-truncate d-flex mt-3 mt-md-0">
                    <i class="ri-user-3-fill text-white"></i>
                    <span class="ml-2 text-capitalize text-white">jaypee Mussorie</span>
                </div> -->
        <div class="row text-right justify-content-end">
          <div class="p-2 align-content-center cursor-pointer" (click)="openTodoList()">
            <span class="text-white todo-span">
              <img src="../../../assets/images/header_todo_icon.svg" alt="" />
            </span>
          </div>

          <div class="p-2 px-3" (click)="openNotifications()">
            <span class="text-white">
              <i class="ri-notification-2-fill notifications">
                <!-- <span *ngIf="newCount" class="countMark"></span> -->
              </i>
            </span>
          </div>

          <div class="btn-group wotToggleDrDwn text-dark d-block my-auto" ngbDropdown role="group">
            <button class="btn text-white border btn-block border-0 p-1" ngbDropdownToggle>
              <strong><i class="ri-user-3-fill px-2 text-white"></i> </strong>
            </button>
            <div class="dropdown-menu text-center userDropdown" ngbDropdownMenu>
              <!-- <button disabled (click)="getPrinterData()" ngbDropdownItem>
                Select Printer
              </button> -->
              <span ngbDropdownItem>
                <h6 class="m-0">{{ userName }}</h6>
              </span>
              <span ngbDropdownItem>
                <span class="role btn btn-outline-primary text-primary btn-sm">{{ userRole }}</span>
              </span>
              <!-- <button (click)="changePassword(content)" ngbDropdownItem>
                Change Password
              </button> -->
              <!-- <button (click)="aboutUpdates(aboutContent)" ngbDropdownItem>About</button> -->
              <button (click)="logout()" ngbDropdownItem>Sign Out</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="pt-100"></div>

<ng-template #content let-modal>
  <div class="modal-header border-0">
    <h6 id="modal-basic-title"><strong> Change Password</strong></h6>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #form="ngForm">
      <div class="form-group">
        <input [(ngModel)]="change_user_details.old_password" appMatInput id="old_password" class="form-control"
          type="password" name="old_password" #old_password="ngModel" (ngModelChange)="check_old_password($event)"
          required />
        <label for="old_password" class="mat-label">Old Password</label>
        <small class="text-danger" *ngIf="wrong_password == 'Incorrect User or Password'">{{ wrong_password }}</small>
        <small class="text-success" *ngIf="wrong_password == 'Password matched'">{{ wrong_password }}</small>
      </div>
      <div class="form-group">
        <input [(ngModel)]="change_user_details.new_password" appMatInput id="newPassword" class="form-control"
          type="password" name="new_password" #new_password="ngModel"
          pattern="^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,20}$" maxlength="20" required />
        <label for="newPassword" class="mat-label">New Password</label>
        <small class="text-mute note-font"><b>Note </b> : should contain special characters and alphanumeric
          with min 6 and max 20 characters</small><br />
        <small class="text-danger" *ngIf="form.submitted && new_password?.errors?.required">Required</small>
        <small class="text-danger" *ngIf="form.submitted && new_password.errors.pattern">Check password pattern</small>
        <small class="text-danger" *ngIf="
            new_password?.value && new_password?.value == old_password?.value
          ">Try new password</small>
      </div>

      <div class="form-group">
        <input appMatInput id="confirmPassword" class="form-control" type="password" name="confirmPassword"
          [(ngModel)]="change_user_details.confirmPassword" #confirmPassword="ngModel" required />
        <label for="confirmPassword" class="mat-label">Confirm Password</label>
        <small class="text-danger" *ngIf="
            new_password?.value != confirmPassword?.value &&
            confirmPassword?.value
          ">password mismatch</small>
      </div>

      <div class="d-flex justify-content-center py-3">
        <button type="button" class="btn btn-outline-dark mx-2" (click)="modal.close('Save click')">
          Cancel
        </button>
        <button type="button" (click)="onSubmit(form)" [disabled]="
            form.valid &&
            (wrong_password == 'Incorrect User or Password' ||
              new_password?.value != confirmPassword?.value ||
              new_password?.value == old_password?.value)
          " class="btn btn-primary">
          Confirm
        </button>
      </div>
    </form>
    <!-- <h6>Do you want to change password?</h6> -->
  </div>
</ng-template>

<ng-template #selectPrinter let-modal>
  <div class="modal-header border-0 bg-gray printer-modal">
    <div>
      <h6 id="modal-basic-title" class="mb-0">
        <strong> Select Printers</strong>
      </h6>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <i class="ri-close-fill"></i>
    </button>
  </div>
  <div class="modal-body printers-list py-0">
    <div class="search-box">
      <div class="input-group input-group-sm border-0">
        <div class="input-group-prepend">
          <span class="input-group-text bg-white border-0"><i class="ri-search-line"></i></span>
        </div>
        <input [(ngModel)]="searchText" type="text" class="form-control border-0" placeholder="Search Printers" />
      </div>
    </div>
    <form #printerForm="ngForm">
      <div class="form-group">
        <ul class="p-0 list-unstyled min-list">
          <li class="cursor-pointer" *ngFor="let item of printers | searchFilter : searchText"
            (click)="selectedPRinter(item)">
            <i [ngClass]="{
                'ri-printer-fill text-success': checkPrinter === item
              }"></i>
            <i [ngClass]="{ 'ri-printer-line': checkPrinter !== item }"></i>
            <span class="ml-2">{{ item }}</span>
          </li>
        </ul>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #aboutContent let-modal>
  <div class="modal-header border-0">
    <h6 id="modal-about-title"><strong>About</strong></h6>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- <p>Version : <b>{{tagUpdate?.name}}</b></p>
        <p>Description : <b> {{tagUpdate?.release?.description}}</b></p> -->
    <p>Version : <b>V5-1-1 </b></p>
    <p>
      Description :
      <b> E-tax invoice download option provided based on TIN number </b>
    </p>
    <p *ngIf="branchUpdate?.commit?.message">
      Last Patch Message : <b> {{ branchUpdate?.commit?.message }}</b>
    </p>
  </div>
</ng-template>

<ng-template #updating let-modal>
  <div class="modal-header border-0">
    <h6 id="modal-about-title">
      <span class="badge-warning px-2" style="top: 4px"></span> Updating
    </h6>
  </div>
  <div class="modal-body">
    <div class="my-4">
      <ngb-progressbar [type]="progressInfos.color" textType="white" [value]="progressInfos.uploadProgress"
        [showValue]="true">
      </ngb-progressbar>
    </div>
    <div>
      <small class="text-center">
        <b>Note </b>: Your system is being updated, please do not refresh. Page
        would be redirected to Login screen, please reload (ctrl+shift+R) before
        login</small>
    </div>
    <!-- <div class="my-0">
            <ng-lottie height="20%" [options]="options" (animationCreated)="animationCreated($event)" (loopComplete)="onLoopComplete()"></ng-lottie>
        </div> -->
  </div>
</ng-template>
<div class="file-upload" *ngIf="fileUPload">
  <div class="card">
    <ngb-accordion #acc="ngbAccordion" [closeOthers]="true" activeIds="static-1">
      <ngb-panel id="static-1">
        <ng-template ngbPanelTitle class="p-0 m-0">
          <div class="card-header d-flex justify-content-between py-2 align-items-center">
            <p class="m-0 file-title d-flex">
              Upload File
              <span class="tick-mark" *ngIf="uploadProgress.status != 'SUCCESS'">
                <div class="box">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </span>
              <span class="tick-mark" *ngIf="uploadProgress.status == 'SUCCESS'"><img height="15" class="rounded-circle"
                  src="assets/images/submittedicon.png" alt="" /></span>
            </p>
            <button type="button" class="close text-white">
              <i class="ri-arrow-down-s-line"></i>
            </button>
            <button *ngIf="uploadProgress.status == 'SUCCESS'" type="button" class="close2 text-white"
              (click)="uploadClose()">
              <i class="ri-close-line"></i>
            </button>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="card p-0">
            <div class="card-body p-0 h-40">
              <div class="p-3" *ngIf="uploadProgress.status == 'STARTED'">
                <!-- <h2 class="text-center p-5">{{uploadProgress.label}}</h2> -->
                <div class="d-flex">
                  <small class="justify-content-between align-items-center"><b>{{ excelUploadData.createdCount }}/{{
                      excelUploadData.totalCount
                      }}</b></small>
                </div>
                <div *ngIf="uploadProgress?.status != 'SUCCESS'">
                  <ngb-progressbar [animated]="true" [title]="'progress bar'" [type]="uploadProgress.color"
                    textType="white" [value]="uploadProgress.progress" [showValue]="true">
                  </ngb-progressbar>
                </div>
              </div>
              <div *ngIf="uploadProgress.status == 'SUCCESS'"
                class="py-4 p-2 d-flex justify-content-between align-items-center">
                <h6 class="text-center text-success mt-2">
                  File uploaded successfully!
                </h6>
                <button type="button" class="btn btn-outline-primary btn-sm px-3"
                  *ngIf="uploadProgress.status == 'SUCCESS'" (click)="uploadClose()">
                  Ok
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
</div>
<div class="file-upload" *ngIf="bulksync">
  <div class="card">
    <ngb-accordion #acc="ngbAccordion" [closeOthers]="true" activeIds="static-2">
      <ngb-panel id="static-2">
        <ng-template ngbPanelTitle class="p-0 m-0">
          <div class="card-header d-flex justify-content-between py-2">
            <p class="m-0 file-title d-flex">
              Bulk Sync Lock
              <span class="tick-mark" *ngIf="syncInvoices?.type != 'Completed'">
                <div class="box">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </span>
              <span class="tick-mark" *ngIf="syncInvoices?.type == 'Completed'"><img height="15" class="rounded-circle"
                  src="assets/images/submittedicon.png" alt="" /></span>
            </p>
            <button type="button" class="close text-white">
              <i class="ri-arrow-down-s-line"></i>
            </button>
            <button *ngIf="
                syncInvoices?.type == 'Completed' ||
                syncInvoices?.type == 'Error'
              " type="button" class="close2 text-white" data-dismiss="modal" (click)="syncClose()">
              <i class="ri-close-line"></i>
            </button>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="card p-0">
            <div class="card-body p-0">
              <table class="table m-0">
                <tbody>
                  <tr *ngIf="syncInvoices?.type == 'Processing'">
                    <td>{{ syncInvoices?.type }}</td>
                    <td class="text-right">
                      <div class="spinner-border text-warning"></div>
                      <!-- Show spinner during processing -->
                    </td>
                  </tr>
                  <tr *ngIf="syncInvoices?.type == 'Error'">
                    <td>{{ syncInvoices?.type }}</td>
                    <td class="text-right">
                      <div class="d-flex align-items-center">
                        <i class="ri-close-circle-fill text-danger icon-success"></i>
                        <small *ngIf="syncInvoices?.error_message" class="text-danger">
                          {{ syncInvoices?.error_message }}
                        </small>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="syncInvoices?.type == 'Completed'">
                    <td>{{ syncInvoices?.type }}</td>
                    <td class="text-right">
                      <i class="ri-checkbox-circle-fill text-success icon-success"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
</div>

<app-bulk-upload-excel-progressbar *ngIf="bulkUploadExcel"
  (item)="changeStatusOfCom($event)"></app-bulk-upload-excel-progressbar>